"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
const AddToCart_1 = __importDefault(require("@/Components/UI/AddToCart/AddToCart"));
const Types_1 = require("@/Types");
const Utils_1 = require("@/Utils");
const useTranslate_1 = require("@/Hooks/useTranslate");
const useStockStatus_1 = require("@/Hooks/useStockStatus");
const useUnits_1 = require("@/Hooks/useUnits");
const useUserData_1 = __importDefault(require("@/Hooks/useUserData"));
const AddToCartWrapper = ({ product, listIndex, listName }) => {
    var _a, _b;
    const { prices, unit, stocks, productionStatusCode } = product;
    const { t } = (0, useTranslate_1.useTranslate)();
    const { stockStatus } = (0, useStockStatus_1.useStockStatus)(stocks, productionStatusCode);
    const { unitDecode } = (0, useUnits_1.useUnits)();
    const userData = (0, useUserData_1.default)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    return (react_1.default.createElement(styled.AddToCartContainer, null,
        react_1.default.createElement(AddToCart_1.default, { type: Types_1.VariantTypes.FULL_VIEW, code: (_a = product.productCode) === null || _a === void 0 ? void 0 : _a.value, isLoading: isLoading, setIsLoading: setIsLoading, price: (0, Utils_1.generateAddToCartPriceString)(prices, t), unit: (_b = prices === null || prices === void 0 ? void 0 : prices[0]) === null || _b === void 0 ? void 0 : _b.unitId, multiple: unit, packageSize: stocks && stocks[0].packageSize, withAddButton: true, stockStatus: stockStatus, isAuthenticated: userData === null || userData === void 0 ? void 0 : userData.isAuthenticated, additionalCharge: (0, Utils_1.getAdditionalCharge)(prices), prices: prices, discountInfo: prices && prices.length > 1 && (0, Utils_1.getDiscountData)(t, prices, unitDecode), productName: product.productName, partNumber: product.partNumber, productBrand: product.brand, productLineLogo: product.productLineLogo, breadcrumbs: product.breadcrumb, centerAlign: true, listName: listName, listIndex: listIndex, productionStatusCode: product.productionStatusCode, customerSpecificCode: product.customerSpecificCode })));
};
exports.default = AddToCartWrapper;
